import React from 'react';

/**
 * Unified Progress Bar Component
 * Shows completion progress
 */
const ProgressBar = ({ 
  current, 
  total, 
  showLabel = true,
  showPercentage = true,
  size = 'md', // sm, md, lg
  color = 'primary', // primary, secondary, success
  className = ''
}) => {
  const percentage = Math.round((current / total) * 100);
  
  const sizeStyles = {
    sm: 'h-2',
    md: 'h-3',
    lg: 'h-4'
  };
  
  const colorStyles = {
    primary: 'bg-primary-600',
    secondary: 'bg-secondary-600',
    success: 'bg-green-600'
  };
  
  return (
    <div className={`w-full ${className}`}>
      {showLabel && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-slate-300">
            Progress
          </span>
          {showPercentage && (
            <span className="text-sm font-semibold text-slate-100">
              {percentage}%
            </span>
          )}
        </div>
      )}
      <div className={`w-full bg-slate-700 rounded-full overflow-hidden ${sizeStyles[size]}`}>
        <div 
          className={`${sizeStyles[size]} ${colorStyles[color]} rounded-full transition-all duration-500 ease-out`}
          style={{ width: `${percentage}%` }}
        >
          {size === 'lg' && (
            <div className="h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse" />
          )}
        </div>
      </div>
      {showLabel && (
        <div className="mt-1 text-xs text-slate-400">
          {current} of {total} completed
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
